class pgweb.ColumnToggleMemory
	
	constructor: ->
		tableId = $('[data-mode=columntoggle]').attr('id')
		if !tableId then return
		
	instance = null
	
	pageId = null
	
	@inst: ->
		if not instance?
			instance = new @
		instance

	@init: ->
		$(document).on 'pagecreate', '[data-role=page]', (event) ->
			pageId = $(event.target).attr('id')
			tableId = getTableId()
			if !tableId then return
			$('#'+tableId+'-popup').popup {history: false}

			# Handle click on checkboxes in column select menu.
			$('body').on 'change', '.ui-table-columntoggle-popup .ui-checkbox input', (event) ->
				tableId = $(event.target).closest('.ui-table-columntoggle-popup').attr('id')
				label = $(event.target).parent().find('label')
				checkBoxText = label.text().trim()
				selectedHeader = findHeaderByText checkBoxText
				bool = $(event.target).is(':checked')
				# Tables whose headers do not carry a "coltitle-*" id cannot be
				# remembered by column, but the toggle must still work. Guard so
				# a missing id does not abort the handler with an exception.
				headerId = selectedHeader and selectedHeader.attr 'id'
				if tableId and headerId
					setColumnToggleCookie tableId, headerId, bool
					label.addClass 'columntoggle-remembered'
				# Chromium sometimes fails to repaint the table area vacated by a
				# hidden column while the toggle popup (a fixed overlay) is open,
				# leaving it showing the page background until the next full
				# repaint. Force a repaint of the table after the widget has
				# applied the column visibility.
				table = if selectedHeader then selectedHeader.closest 'table' else $()
				window.setTimeout (-> forceTableRepaint table), 0
			
			# Add reset button
			html = '<div><input type="button" class="columntoggle-reset-button" id="columntoggle-reset-button" '
			html += 'value="'+t.Reset+'" data-theme="b"/></div>'
			$('#'+tableId+'-popup fieldset .ui-controlgroup-controls').parent().parent().append html
			$('.columntoggle-reset-button').button()
			$('body').on 'click', '.columntoggle-reset-button', (event) ->
				onResetButtonClick()
			
			# First we need to clear all checkboxes which have cookie = false.
			checkOrClearCheckBoxes tableId, false
			
			# Then we can set all checkboxes which have cookie = true.
			checkOrClearCheckBoxes tableId, true
	
	checkOrClearCheckBoxes = (tableId, check) ->
		getHeaders().each (i, el) ->
			headerId = $(el).attr('id')
			if !headerId then return
			headerText = $('#'+headerId).html().trim()
			if headerText
				columnToggleMenuItem = findColumnToggleMenuItemByText headerText
				if columnToggleMenuItem
					input = columnToggleMenuItem.find('input')
					if existsColumnToggleCookie tableId, headerId
						input.parent().find('label').addClass 'columntoggle-remembered'
						if check
							if getColumnToggleCookie(tableId, headerId) == true # Cookie is true
								if not input.is(':checked') # ... but checkbox is false
									input.click() # ... so simulate a click to set it to true
						else
							if getColumnToggleCookie(tableId, headerId) == false # Cookie is false
								if input.is(':checked') # ... but checkbox is true
									input.click() # ... so simulate a click to set it to false
	
	onResetButtonClick = ->
		tableId = getTableId()
		getHeaders().each (i, el) ->
			headerId = $(el).attr('id')
			if !headerId then return
			if existsColumnToggleCookie tableId, headerId
				removeColumnToggleCookie tableId, headerId
		location.reload()
	
	# Find a th element by looking for its text e.g. 'Adress'
	findHeaderByText = (headerTextToFind) ->
		selectedHeader = undefined
		headers = getHeaders()
		headers.each (i, el) ->
			if selectedHeader then return
			header = $(el)
			headerText = header.text()
			if headerText == headerTextToFind
				selectedHeader = header
		selectedHeader
	
	getHeaders = ->
		headers = $('#'+pageId+' [data-mode=columntoggle] th > span')
		if headers.length == 0
			headers = $('#'+pageId+' [data-mode=columntoggle] th')
		headers
	
	getTableId = ->
		$('#'+pageId+' [data-mode=columntoggle]').attr('id')
	
	# Find a column toggle column menu item by looking for its text e.g. 'Adress'
	findColumnToggleMenuItemByText = (checkBoxTextToFind) ->
		retItem = undefined
		tableId = getTableId()
		$('#'+tableId+'-popup label').each (j, item) ->
			checkBoxText = $(item).text().trim()
			if checkBoxText == checkBoxTextToFind
				retItem = $(item).parent()
		retItem

	existsColumnToggleCookie = (tableId, selectedHeaderId) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		(pgwebGetCookie cookieName) != undefined
	
	getColumnToggleCookie = (tableId, selectedHeaderId) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		Number(pgwebGetCookie cookieName) == 1
	
	setColumnToggleCookie = (tableId, selectedHeaderId, bool) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		pgwebSetCookie cookieName, Number(bool), 90

	removeColumnToggleCookie = (tableId, selectedHeaderId) ->
		cookieName = getColumnToggleCookieName tableId, selectedHeaderId
		pgwebRemoveCookie cookieName
	
	getColumnToggleCookieName = (tableId, selectedHeaderId) ->
		ret = 'columntoggle_' + tableId.removeEnd('-table').undasherize() + '_'
		ret += selectedHeaderId.removeStart('coltitle-').undasherize() + '_' + pgwebGetCookie 'idHash'
		ret

	# Force the browser to repaint the table body. Hiding a column through
	# the column toggle changes column widths, and Chromium does not always
	# invalidate the vacated table area while the popup (a fixed overlay) is
	# open, so it can keep showing the page background until the next full
	# repaint (e.g. when a mouse-out forces one). Briefly promoting the table
	# body to its own compositing layer and demoting it again forces the
	# rows to be repainted. It does not affect layout and does not touch the
	# sticky header, which is a fixed-position clone inside the thead.
	forceTableRepaint = (table) ->
		return if !table || table.length == 0
		body = table.find 'tbody'
		return if body.length == 0
		body.css 'transform', 'translateZ(0)'
		body[0].offsetHeight
		window.requestAnimationFrame ->
			body.css 'transform', ''

pgweb.ColumnToggleMemory.init()
$(-> pgweb.ColumnToggleMemory.inst())